/**
 * 楓燧大師兄官網 · 三日公開課落地頁 頁面數據
 * 對應設計稿 fengsuidashi_new_landing.html，文案與素材集中管理
 * PC 端與移動端共用本文件，避免兩套文案不一致
 */
import logoLight from '../../../assets/images/logo_light.png';
import logoInk from '../../../assets/images/logo_ink.png';
import heroCutout from '../../../assets/images/hero_cutout.png';
import heroBg from '../../../assets/images/hero_bg.jpg';
import class3Wide from '../../../assets/images/class3_wide.jpg';
import mentor from '../../../assets/images/mentor.jpg';
import cDay1 from '../../../assets/images/c_day1.jpg';
import cDay2 from '../../../assets/images/c_day2.jpg';
import cDay3 from '../../../assets/images/c_day3.jpg';
import iLuopan from '../../../assets/images/i_luopan.png';
import iSword from '../../../assets/images/i_sword.png';
import iHu from '../../../assets/images/i_hu.png';
import iBell from '../../../assets/images/i_bell.png';
import gRedRobe from '../../../assets/images/g_red_robe.jpg';
import gCeremony from '../../../assets/images/g_ceremony.jpg';
import gSword from '../../../assets/images/g_sword.jpg';
import gRitual from '../../../assets/images/g_ritual.jpg';
import gBell from '../../../assets/images/g_bell.jpg';
import gGourd from '../../../assets/images/g_gourd.jpg';
import class1 from '../../../assets/images/class1.jpg';
import class2 from '../../../assets/images/class2.jpg';
import class3Sq from '../../../assets/images/class3_sq.jpg';
import masterTalk from '../../../assets/images/master_talk.jpg';
import note1 from '../../../assets/images/note1.png';
import note2 from '../../../assets/images/note2.png';
import note3 from '../../../assets/images/note3.png';
import review776663 from '../../../assets/images/review_776663.jpg';
import review200345 from '../../../assets/images/review_200345.jpg';
import review301992 from '../../../assets/images/review_301992.jpg';
import review850659 from '../../../assets/images/review_850659.jpg';

// 全站 CTA 統一指向的默認報名連結（渠道跳轉見 utils/channelConfig.js）
export const DEFAULT_CTA_URL = 'https://diversion.salesmartly.com/split/whatsapp/fkyrju';

// 品牌
export const brand = {
  name: '楓燧堂',
  sub: '· 大師兄',
  logoLight,
  logoInk,
};

// 首屏背景：現用真實授課現場 class3_wide.jpg
export const heroData = {
  tag: '香港 · 線上直播 · 全程免費',
  titleBefore: '3 日睇懂自己嘅',
  titleHighlight: '八字方向',
  titleAfter: '財運 · 事業 · 姻緣 · 貴人',
  desc: '《中華道傳智慧公開課》三日班——由楓燧大師兄親授，道傳八字＋道法實修＋修心次第，學完自己都識睇。',
  ctaText: '立即免費報名搶位',
  secondaryText: '先睇下教咩 ↓',
  note: '下一期開課 · 名額有限 · 輸入生辰即送個人專屬排盤',
  cutout: heroCutout,
  cutoutAlt: '楓燧大師兄',
  bg: class3Wide,
  bgFallback: heroBg,
};

// 信任條 4 欄
export const trustItems = [
  { icon: '🏆', title: 'TVB《通靈之王2》總冠軍', sub: '「雷電道長」楓燧 · 大眾認知度高' },
  { icon: '⛰', title: '龍虎山正一派授籙弟子', sub: '正統法脈，唔係江湖術士' },
  { icon: '⏳', title: '十多年玄空風水×子平八字', sub: '譽為「互聯網界環境佈局第一人」' },
  { icon: '🧧', title: '線上線下服務上萬人次', sub: '中華道傳智慧大講堂創始人' },
];

// 三日課程 3 卡
export const courseDays = [
  {
    image: cDay1,
    day: '第 一 堂',
    title: '道傳八字看吉凶',
    desc: '五行影響、八字斷人、道法護身——「算命真係靠譜嗎？」大師兄親自拆解，帶你睇清先天格局同人生走勢。',
    len: '約 139 分鐘 · 信任建立',
  },
  {
    image: cDay2,
    day: '第 二 堂',
    title: '修道實修 × 心靈減壓',
    desc: '金光神咒實修、打通眉心——打開被邏輯思考壓抑嘅心靈，俾長期精神繃緊嘅你一個出口。',
    len: '約 120 分鐘 · 痛點觸動',
  },
  {
    image: cDay3,
    day: '第 三 堂',
    title: '論八字 × 修心次第',
    desc: '止→定→靜→安→慮→得，加井字訣實用技法——由「算命」升維到可落地嘅人生智慧。',
    len: '約 101 分鐘 · 價值深化',
  },
];

// 金句帶 3 欄
export const quotes = [
  { text: '修道，就是在閱讀自己的生命感受。', from: '— 課堂金句' },
  { text: '讓天道來回答你的人生問題。', from: '— 課堂金句' },
  { text: '止而後能定，定而後能靜，靜而後能安。', from: '— 修心次第' },
];

// 師資
export const mentorData = {
  kicker: '主 講 導 師',
  name: '楓燧大師兄',
  alias: '｜本名 易烊楓燧',
  honor: 'TVB《通靈之王2》總冠軍 · 龍虎山正一派授籙弟子 · 中華道傳智慧大講堂創始人',
  image: mentor,
  points: [
    '專注玄空風水、子平八字、手相面相十多年，實戰為本',
    '龍虎山兜率宮國學課堂創始人，正統道教法脈傳承，有實體教學體系',
    '譽為「互聯網界環境佈局第一人」，懂傳統科儀亦懂新媒體傳播',
    '線上直播、諮詢服務、線上授課經驗豐富，唔係純理論派',
  ],
};

// 適合對象 2×2
export const fitItems = [
  {
    icon: iLuopan,
    title: '自己做生意嘅老闆',
    desc: '睇清財運節奏，邊年進取、邊年守，決策多一個依據。',
  },
  {
    icon: iSword,
    title: '準備創業或做緊新項目',
    desc: '揀項目、定方向，用命盤對一對展開嘅時機。',
  },
  {
    icon: iHu,
    title: '掌管團隊嘅管理層',
    desc: '用人、佈局、升遷判斷，多一個參考維度。',
  },
  {
    icon: iBell,
    title: '想為人生下半場做規劃',
    desc: '身家有一定基礎，更想知點樣行得穩、行得遠。',
  },
];

// 形象照（深色相冊）
export const galleryItems = [
  { image: gRedRobe, caption: '道袍科儀' },
  { image: gCeremony, caption: '科儀演示' },
  { image: gSword, caption: '法劍威儀' },
  { image: gRitual, caption: '法音宣流' },
  { image: gBell, caption: '法器傳承' },
  { image: gGourd, caption: '道門日常' },
];

// 課堂實錄（淺色相冊）
export const classItems = [
  { image: class2, caption: '公開課授課現場' },
  { image: class3Sq, caption: '天師道風水專題課' },
  { image: class1, caption: '課後一對一拆盤' },
  { image: masterTalk, caption: '大師兄課堂答問' },
];

// 正式課筆記 3 卡
export const noteItems = [
  { image: note1, cap: '第一式 · 攝固觀像', sub: '松靜站立，心中觀想' },
  { image: note2, cap: '第二式 · 金光融身', sub: '默念持咒，金光觀想' },
  { image: note3, cap: '第三式 · 虔誠請動', sub: '至誠念誦，恭請駕臨' },
];

export const noteDisclaimer = '* 筆記為正式課教材節錄，道法儀式內容僅供文化體驗及民俗交流參考。';

// 學員反饋截圖
export const reviewItems = [
  { image: review776663, cap: '「感謝大師兄」' },
  { image: review200345, cap: '課後心得分享' },
  { image: review301992, cap: '「感謝大師兄教導」' },
  { image: review850659, cap: '「預測結果全部都中」' },
];

export const reviewDisclaimer = '* 截圖已作私隱處理，反饋為個別學員分享，不構成對任何結果嘅保證。';

// 報名流程 4 步
export const stepItems = [
  { n: '01', title: '點 WhatsApp 按鈕', desc: '撳頁面上任何一個「免費報名」按鈕。' },
  { n: '02', title: '入群留位', desc: '師兄拉你入公開課群組，確認開課時間。' },
  { n: '03', title: '提供生辰', desc: '輸入出生年月日時，即刻收到專屬排盤。' },
  { n: '04', title: '準時上課', desc: '三日跟住大師兄，由排盤學到應用。' },
];

// FAQ 6 條
export const faqItems = [
  {
    q: '成個課程真係免費？',
    a: '係。三日公開課全程免費，報名只需入 WhatsApp 群組留位。早鳥報名仲送全套課程資料。',
  },
  {
    q: '完全唔識命理，跟得上嗎？',
    a: '跟得上。課程專為零基礎入門而設，由排盤教起，大師兄會用生活例子逐步講解。',
  },
  {
    q: '唔記得自己嘅出生時辰，可以嗎？',
    a: '可以照參加。提供出生年月日即可先排盤上課；時辰資料之後想補充，可以喺群組同師兄講。',
  },
  {
    q: '上課係邊度上？',
    a: '線上直播，用手機或電腦都得。報名後開課時間同連結會喺 WhatsApp 群組公佈。',
  },
  {
    q: '同一般算命有咩唔同？',
    a: '唔係幫你算一次就完。公開課教識你用道傳八字自己睇，仲有金光神咒實修同修心次第，由「問人」變「識自己」。',
  },
  {
    q: '聽完之後有下一步嗎？',
    a: '有興趣深入了解嘅學員，可以喺課後自行選擇是否繼續跟進系統課程，無任何強制。',
  },
];

// 底部 CTA
export const finalCtaData = {
  titleBefore: '下一期開課在即 · ',
  titleHighlight: '免費名額有限',
  desc: '輸入生辰即獲個人專屬八字排盤，三日學會睇自己嘅運。先到先得，滿位即止。',
  btnText: '立即進 WhatsApp 群搶位聽課',
  note: 'WhatsApp：+852 4743 8611 ｜ 免費公開課 · 無任何隱藏收費',
};

// 頁尾
export const footerData = {
  copyright: '© 2026 楓燧堂 · 楓燧大師兄',
  disclaimer: '內容僅供傳統文化學術交流參考 · 道法儀式內容僅供文化體驗及民俗交流參考',
};

// 導航欄按鈕
export const navCtaText = 'WhatsApp 免費報名';
